/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import 'overlayscrollbars/js/jquery.overlayScrollbars'
import objectFitImages from 'object-fit-images';
import './modernizr-touch'

// polyfill for IE11
$(function () {
  objectFitImages();
})

$(window).on('load', () => {
  // init global scope vars
  const $body = $('body');
  const $win = $(window);
  const $agbPage = $('.agb-impressum')
  const $intro = $('#intro');
  // Basic stuff we use around the script
  const headerHeight = $('header').outerHeight() + 2

  /**
   * Init custom scrolling
   * We use two separated scrollbars for the body and the agb/impressum overlay
   * @type {*|jQuery}
   */
  const barOptions = {
    className: 'os-theme-dark',
    resize: 'both',
    sizeAutoCapable: true,
    paddingAbsolute: true,
    autoUpdate: true,
    scrollbars: {
      clickScrolling: true,
    },
    overflowBehavior: {
      x: 'hidden',
    },
  }
  const bar = $body.overlayScrollbars(barOptions).overlayScrollbars();
  const footerBar = $agbPage.overlayScrollbars(barOptions).overlayScrollbars();

  /**
   * add animation (moving effect) on intro-elements
   */
  function animateIntro($div, theSpeed, minus) {
    let startX;
    let startY;
    let pixelToMove = theSpeed;

    $intro.mouseenter(function (e) {
      startX = e.clientX;
      startY = e.clientY;
    });

    $win.mousemove(function (e) {
      let width = $($div).innerWidth();
      let height = $($div).innerHeight();
      let newValueX = (startX - e.pageX) / width * pixelToMove * minus;
      let newValueY = (startY - e.pageY) / height * pixelToMove * minus;
      $($div).css({
        'marginLeft': newValueX + 'px',
        'marginTop': newValueY + 'px',
      });
    });
  }

  animateIntro('#intro img', 30, 1)

  /**
   * Go directly to tab, when Hashtag is set (and page with that hash is set)
   * else load intro image and text
   */
  let theHash = window.location.hash.slice(1);
  let theHashHeading = '#heading-' + theHash;

  if (window.location.hash && document.querySelectorAll('.card.' + theHash).length > 0) {
    $('.card.' + theHash)
      .find('.collapse').collapse('show')
      .on('shown.bs.collapse', function () {
        bar.update();
        bar.scroll({y: $(theHashHeading).offset().top - headerHeight + 1}, 0)
        setTimeout(() => {
          fadeOutIntro()
        }, 100)
      })
  } else if (window.location.hash && document.querySelectorAll('.agb-impressum #' + theHash).length > 0) {
    $agbPage.removeClass('hide')
    $body.addClass('no-scroll')
    showFooter(theHash)

    setTimeout(() => {
      fadeOutIntro()
    }, 100)
  } else {
    fadeInIntro()
  }

  /**
   * Remove intro site on click
   */
  $intro.on('click touchmove wheel', function() {
    fadeOutIntro()
  });

  function fadeOutIntro() {
    $('#intro .title, #intro .subtitle').removeClass('fade-in')

    $intro.animate({
        'opacity': '0',
      }, 400, function() {
        $intro.addClass('hide')
        $body.removeClass('no-scroll')
      })
  }

  function fadeInIntro() {
    $('body').addClass('no-scroll');
    $intro
      .removeClass('hide')
      .animate({
        'opacity': '1',
      }, 400, function() {
        $('#intro .title, #intro .subtitle').addClass('fade-in')
      })

    /**
     * Fadein image on intro site
     */
    $('#intro img').on('load', function() {
      $(this).addClass('fade-in')
    }).each(function() {
      if(this.complete && this.naturalHeight !== 0) {
        $(this).trigger('load');
      }
    });
  }

  /**
   * animate scroll function
   * @param pos
   */
  function scrollTo(pos) {
    bar.scroll({y: pos}, 250)
  }

  /**
   * remove text after Hash in URL, and hash too
   */
  function removeHash() {
    history.pushState({}, document.title, ".");
  }

  /**
   * scroll to top of the page if user click on logo
   * collapse all open cards
   * show intro again
   */
  $('.brand').on('click', function(e) {
    e.preventDefault();
    if(window.location.pathname === '/') {
      removeHash();
      fadeInIntro();
      scrollTo(0);

      $('#accordion .card .collapse').each(function() {
        $(this).collapse('hide')
      })
    } else {
      window.location.href = '/'
    }
  });

  $('#accordion .card')
    /**
     * Scroll to opened card after accordion transition is over
     */
    .on('shown.bs.collapse', function() {
      bar.update();
      scrollTo(bar.scroll().position.y + $(this).offset().top - headerHeight + 1)
    })

    /**
     * toggle class ".open" on card-header
     */
    .on('show.bs.collapse', function() {
      $(this).find('.card-header').addClass('open')
    })
    .on('hide.bs.collapse', function() {
      $(this).find('.card-header').removeClass('open')
    });

  /**
   * toggle collapse-function when clicking on whole card-header, not only on button
   */
  $('.card-header').on('click', function() {
    $(this).parent().find('.collapse').collapse('toggle')
    let thePage = $(this).attr('hash')

    // set hashes
    if(window.location.hash === '#' + thePage) {
      removeHash()
    } else {
      window.location.hash = thePage
    }
  })

  /**
   * Helper function to open an internal link
   * todo: we should use a more declarative approach. Add a class for internal links or so
   * @param hash
   * @param page
   */
  function collapseLink(hash, page) {
    $('a[href$="' + hash + '"]').on('click', function(e) {
      e.preventDefault();
      $('.card').collapse('hide')
      $('#heading-' + page).addClass('open')
      $('#collapse-' + page).collapse('show');
    })
  }
  collapseLink('#mail', 'kontakt')

  /**
   * add ".open"-class to open cards.
   * remove it on close
   */

  /**
   * function that fires, when clicking on agb or impressum
   * @param id
   */
  function showFooter(id) {
    $agbPage.removeClass('hide')
    $body.addClass('no-scroll')

    if (id) {
      window.location.hash = '#' + id;
      window.location.pathname = '/'; // for posts single pages
      let position = document.getElementById(id).offsetTop
      footerBar.update();
      footerBar.scroll({y: position - 15}, 400)
    } else {
      footerBar.update();
      footerBar.scroll({y: 0 - headerHeight - 15}, 400)
    }
  }
  $('.agb-btn').on('click', () => showFooter('agb'))
  $('.impressum-btn').on('click', () => showFooter('impressum'))


  /**
   * Close AGB or impressum on click on close button or on click on header brand
   */
  $('header .brand, .agb-impressum button.close-btn').on('click', function() {
    removeHash();
    $body.removeClass('no-scroll');
    $agbPage.addClass('hide')
  });

  /*
  copy Data from contactform to newsletter
   */
  function setMailerliteData() {
    let theFirstname;
    let theLastname;
    let theEmail;
    theFirstname = document.querySelector('.wpcf7 .firstname input').value;
    theLastname = document.querySelector('.wpcf7 .lastname input').value;
    theEmail = document.querySelector('.wpcf7 .email input').value;

    document.getElementById('mailerlite-1-field-email').value = theEmail
    document.getElementById('mailerlite-1-field-name').value = theFirstname
    document.getElementById('mailerlite-1-field-last_name').value = theLastname
  }

  /*
  load and submit mailerlite-form, if checkbox for newsletter is checked
   */
  function sendMailerlite() {
    $('.wpcf7-submit').on('click', function(e) {
      if(document.querySelector('.checkbox-815 input').checked) {
        e.preventDefault();
        setMailerliteData();

        // not so nice, but with async/await it didn't work
        setTimeout(() => {
          $('.mailerlite-form form').submit();
          $('#wpcf7-f122-o1 form').submit();
        }, 500)
      }
    })
  }

  sendMailerlite()


  /*async function sendMailerLite() {
    $('.wpcf7-submit').on('click', async function(e) {
      e.preventDefault();
      await setMailerLiteDate();
    }
  }*/

  /*function sendMailerLite() {
    let fillMailerLite = new Promise((resolve, reject) => {
      let theFirstname;
      //let theLastname;
      //let theEmail;
      theFirstname = document.querySelector('.wpcf7 .firstname input').value;
      //theLastname = document.querySelector('.wpcf7 .lastname input').value;
      //theEmail = document.querySelector('.wpcf7 .email input').value;

      console.log(theFirstname);

      document.getElementById('mailerlite-1-field-email').value = theEmail
      //document.getElementById('mailerlite-1-field-name').value = theFirstname
      //document.getElementById('mailerlite-1-field-last_name').value = theLastname

      resolve('success');
      reject('failed')
    })

    $('.wpcf7-submit').on('click', function(e) {
      if(document.querySelector('.checkbox-815 input').checked) {
        e.preventDefault();

        //fillMailerLite().then(document.getElementById('mailerlite-form_1').submit(), isError);
        fillMailerLite.then((message) => {
          console.log('text succ: ' + message);
          $('#mailerlite-form_1').submit();
          //document.getElementById('mailerlite-form_1').submit;
        }).catch((message) => {
          console.log('error text: ' + message)
        });
      }
    })
  }*/

  //sendMailerLite()
});
